<template>
  <div>
     <b-form @submit.prevent="save">
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <b-form-group
                :label="$t('reporting_channel.general_orientation')"
                label-for="general_orientation">
              <validation-provider
                #default="{ errors }"
                name="general_orientation">
                <complex-editor :editor_data.sync="general_orientation"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <b-form-group
                :label="$t('receiving_emails')"
                label-for="emailsInput">
              <validation-provider
                #default="{ errors }"
                name="emailsInput">
                <!--Tags input-->
                <emails-input
                  ref="emailsInput"
                  :emailsInput="emailsInitialTag"
                  @emailsChanged="emailsChanged"
                  :sendButton="false"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <div class="flex justify-end mb-4">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right mr-1"
            type="submit">
            Salvar
          </b-button>
          <b-button
              v-if="!hideBackButton"
              variant="outline-secondary"
              class="float-right"
              @click="goBack">
              <feather-icon
                icon="CornerUpLeftIcon"
                class="mr-50"/>
              <span class="align-middle">{{$t('back')}}</span>
          </b-button>
        </div>
     </b-form>
      <!-- -->
      <b-card-code
        :key="`${legalEntityId}-rc-form`"
        :title="$t('reporting_channel.url_to_form')"
        codeVisible="true"
        showCopy="true"
        codeEmbed="true"
        :shortUrl="shortUrl">
        <b-card-text>
          Use esta URL para que a instituição/empresa possa abrir o formulário.
        </b-card-text>
        <template #code>
          {{ formUrl }}
        </template>
      </b-card-code>

      <b-card-code
        :key="`${legalEntityId}-rc-protocol`"
        title="Protocolo - Página de Consulta Pública"
        codeVisible="true"
        showCopy="true"
        codeEmbed="true">
        <b-card-text>
          Use esta URL para realizar consulta da situação e tratamento do formulário de Relato.
        </b-card-text>
        <template #code>
          {{ protocolQueryUrl }}
        </template>
      </b-card-code>
      <div v-if="!hideBackButton" class="flex justify-end">
        <b-button
            variant="outline-secondary"
            class="float-right"
            @click="goBack">
            <feather-icon
              icon="CornerUpLeftIcon"
              class="mr-50"/>
            <span class="align-middle">{{$t('back')}}</span>
          </b-button>
      </div>
  </div>
</template>

<script>
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BCardText, BFormInput
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardCode from '@core/components/b-card-code'
import ComplexEditor from '@/components/ComplexEditor.vue'
import EmailsInput from '@/components/EmailsInput.vue'

import ReportingChannelConfigService from '@/services/api/reporting-channel/ReportingChannelConfigService'

export default {
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardCode,
    BCardText,
    BFormInput,
    // validations
    ValidationProvider,
    ValidationObserver,
    ComplexEditor,
    EmailsInput,
  },
  props: {
    legalEntityId: {
      type: Number,
      default: null
    },
    legalEntityRecord: {
      type: Object,
      default: null
    },
    hideBackButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      legalEntity: null,
      general_orientation: '',
      emails: [],
      emailsInitialTag: [],
      service: ReportingChannelConfigService.build(this.$vs)
    }
  },
  watch: {
    legalEntityRecord: {
      immediate: true,
      handler(val) {
        if (val != null) {
          this.legalEntity = val
          if (this.legalEntityId) {
            this.getData(this.legalEntityId)
          }
        }
      }
    },
    //Não retirar, verificar a lógica da consulta da legalEntity
    '$store.state.legalEntity.legalEntity': {
      immediate: true,
      handler(legalEntity) {
        if (this.legalEntityRecord != null) {
          return
        }
        this.legalEntity = legalEntity
        if (this.legalEntity && this.legalEntityId) {
          this.getData(this.legalEntity.id)
        }
      }
    }
  },
  computed: {
    formUrl() {
      if (this.legalEntity && this.legalEntity.reporting_channel_url) {
        return `${this.legalEntity.reporting_channel_url}`
      }
      return ''
    },
    protocolQueryUrl() {
      if (this.legalEntity && this.legalEntity.reporting_channel_protocol_query_url) {
        return `${this.legalEntity.reporting_channel_protocol_query_url}`
      }
      return 'unknown'
    },
    shortUrl(){
      if (this.legalEntity && this.legalEntity.reporting_channel_short_url) {
        return `${this.legalEntity.reporting_channel_short_url}`
      }
      return null
    },
  },
  methods: {
    goBack() {
      if (this.hideBackButton) {
        return
      }
      this.$store.commit('legalEntity/UPDATE_LEGAL_ENTITY', null)
      this.$router.push({name: 'people-legal-entities'})
    },
    getData(id) {
      this.$vs.loading()
      this.service.read(id).then(
        data => {
          this.emailsInitialTag = _.get(data, 'data.emails');
          this.general_orientation = _.get(data, 'description');
          this.$vs.loading.close()
        },
        error => {
          this.$vs.loading.close()
        }
      )
    },
    save() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      const params = {
        id: this.legalEntityId,
        legal_entity_id: this.legalEntityId,
        description: this.general_orientation ? this.general_orientation : '',
        emails: this.emails
      }

      this.service.createOrUpdate(params).then(
        data => {
          this.notifySuccess(this.$vs)
        },
        error => {
          this.showErrors(this.$validator, error)
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    emailsChanged(emails) {
      this.emails = emails
    }
  },
  mounted() {
    if (this.legalEntityRecord != null) {
      return
    }
    if (this.legalEntityId && !this.legalEntity) {
      this.getData(this.legalEntityId)
    }
  },
  beforeDestroy() {
    this.destroyChilds(this)
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
